import { Link } from "react-router";

function ResetPasswordError() {
  return (
    <div className="card w-full max-w-md bg-base-100 shadow-xl">
      <div className="card-body items-center text-center">
        <div className="w-24 h-24 rounded-full bg-error/20 flex items-center justify-center mb-4">
          <svg className="w-12 h-12 text-error" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>

        <h2 className="card-title text-2xl font-bold text-error mb-2">Password Reset Failed</h2>

        <p className="text-base-content/70">
          The password reset link is invalid or has expired. Please request a new password reset link.
        </p>

        <div className="card-actions mt-6 w-full">
          <Link to="/request-reset-password" className="btn btn-primary w-full">
            Request New Link
          </Link>
          <Link to="/login" className="btn btn-outline w-full">
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  )
}

export default ResetPasswordError;